export const parsePercents = (part, total, prec = 1) => (!part || !total)
  ? 0
  : parseFloat((part * 100 / total).toFixed(prec));

